/** @format */

const template = `
<div ng-if="$ctrl.totalItems > 0">
  <table class="table styled-table">
    <thead>
      <tr>
        <th class="sis-untouchable" ng-repeat="column in $ctrl.columns" aria-sort="{{$ctrl.getAriaSortValue(column)}}">
          <button
            type="button"
            class="non-button sorting-button"
            ng-click="$ctrl.setOrder(column)"
            ng-disabled="!$ctrl.isSortColumn(column)"
            aria-label="{{('STUDENT_APPLICATIONS.' + column) | translate}}">
            <span>{{('STUDENT_APPLICATIONS.' + column) | translate}}</span>
            <sis-icon icon="sorter" icon-class="{{$ctrl.getSorterClass(column)}}" ng-if="$ctrl.isSortColumn(column)"></sis-icon>
          </button>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        ng-repeat="application in $ctrl.studentApplicationSearchResult.searchResults track by application.id"
        data-cy="application-search-result">
        <td
          ng-repeat="column in $ctrl.columns"
          ng-switch="column"
          ng-click="$ctrl.navigateToApplication(application)"
          class="clickable"
          ng-class="{'sorted-cell': $ctrl.sortColumn === column}">
          <span ng-switch-when="name">
            <a href="javascript:void(0);" ng-click="$ctrl.navigateToApplication(application)" class="clickable-rows-link">
              <span class="student-application-type">{{('STUDENT_APPLICATIONS.TYPE.' + application.type) | translate}}:</span>
              <span>{{$ctrl.getApplicationName(application)}}</span>
            </a>
          </span>
          <span ng-switch-when="code">
            <span>{{application.code}}</span>
          </span>
          <span ng-switch-when="lastHandlerPerson">
            <span ng-if="application.lastHandlerPersonId">
              <span>{{$ctrl.lastHandlerNames[application.id]}}</span>
              <button
                type="button"
                title="{{'ARIA_LABEL.REMOVE_HANDLER' | translate}}"
                class="link-button"
                ng-if="(application.state === 'REQUESTED' || application.state === 'IN_HANDLING') && !$ctrl.isOnStudentPage"
                ng-click="$ctrl.removeHandler(application); $event.stopPropagation();"
                aria-label="{{'ARIA_LABEL.REMOVE_HANDLER' | translate}}">
                <sis-icon icon="close"></sis-icon>
              </button>
            </span>
            <span
              ng-if="!application.lastHandlerPersonId && (application.state === 'REQUESTED' || application.state === 'IN_HANDLING') && !$ctrl.isOnStudentPage">
              <button
                type="button"
                class="link-button"
                ng-click="$ctrl.setMeAsLastHandler(application); $event.stopPropagation();"
                translate
                >STUDENT_APPLICATIONS.SET_ME_AS_HANDLER</button
              >
            </span>
          </span>
          <span ng-switch-when="state" class="application-status">
            <sis-icon
              icon="{{$ctrl.getStatusIcon(application.state)}}"
              icon-class="{{$ctrl.getStatusIconClass(application.state)}}"></sis-icon>
            <span translate>{{'STUDENT_APPLICATIONS.STATE.' + application.state}}</span>
          </span>
          <span ng-switch-when="approvalDate">
            <span ng-if="application.state !== 'REQUESTED'">
              {{_.get(application, 'applicationDecision.approvalDate') | localDateFormat}}
            </span>
            <span ng-if="application.state === 'REQUESTED'">-</span>
          </span>
          <span ng-switch-when="creationTime">{{application.creationTime | localDateFormat}}</span>
          <span ng-switch-when="lastHandledTime">{{application.lastHandledTime | localDateFormat}}</span>
          <span ng-switch-when="studentName">{{$ctrl.getStudentName(application)}}</span>
          <span ng-switch-default>{{application[column]}}</span>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="row">
    <div class="col-12" ng-if="$ctrl.totalItems > $ctrl.itemsPerPage" data-cy="pagination-controls">
      <sis-pagination
        scroll-into-view-on-page-change="div.scroll-target"
        [total-items]="$ctrl.totalItems"
        [current-page]="$ctrl.currentPage"
        [items-per-page]="$ctrl.itemsPerPage"
        [max-size]="$ctrl.maxSize"
        (current-page-change)="$ctrl.onPageChange($event)">
      </sis-pagination>
    </div>
  </div>
</div>
`;
export default template;
